/**
 * La phrase de la case newsletter, sous les alertes des outils.
 *
 * Un seul endroit pour elle : le composant l'affiche, et le serveur garde
 * celle-ci, jamais celle du navigateur, comme preuve du consentement. Changer
 * un mot ici change aussi ce qui est enregistré pour les inscriptions à venir.
 */
export const CASE_NEWSLETTER = {
    fr: "Recevoir aussi, une fois par mois au plus, ce qui change pour les solopreneurs",
    en: "Also send me, at most once a month, what changes for solopreneurs",
};
